export default { 
  EpotList: require('./EpotList').default,
  EpotCreate: require('./EpotCreate').default,
  EpotCreatex: require('./EpotCreatex').default,
  EpotGreeting: require('./EpotGreeting').default,
  EpotDetail: require('./EpotDetail').default,
  EpotForm: require('./EpotForm').default,
}